<template>
    <div class="moderation" v-if="isMounted" v-can="'settings_moderation.access'">
        <ds-filter
            ssr
            :fields="filters.fields"
            :data="filters.options"
            @submit="submitFilter"
            @resetFilter="refreshFilter"
        >
            <vs-col
                vs-w="12"
                vs-sm="12"
                vs-lg="12"
                vs-xs="12"
            >
                <div class="flex items-center">
                    <div class="m-2 flex items-center">
                        <vs-radio v-model="date.direction" vs-name="send_date" vs-value="send_date">{{ $t('date.send_date') }}</vs-radio>
                    </div>
                    <div class="m-2 flex items-center">
                        <vs-radio v-model="date.direction" vs-name="first_action_date" vs-value="first_action_date">{{ $t('date.first_action_date') }}</vs-radio>
                    </div>
                </div>
            </vs-col>

            <vs-col
                vs-w="12"
                vs-sm="6"
                vs-lg="3"
                vs-xs="12"
            >
                <div class="m-2">
                    <label class="text-sm opacity-75">{{ $t(`date.${date.direction}`) }}</label>
                    <date-picker
                        @select="selectedDate"
                        :date="date"
                        :direction="date.direction"
                    />
                </div>
            </vs-col>
        </ds-filter>

        <ds-table
            spacer
            ssr
            :view-items="[50, 100, 500]"
            :data="leads"
            :heads="heads"
            :total="table.total"
            :max-items="table.limit"
            :page="table.page"
            :disabled="load"
            @page="page"
            @limit="limit"
            @sort="sort"
        >
            <template v-slot:created_at="{created_at}">
                <div v-if="!created_at.created_at">-</div>
                <div v-else>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-calendar', 'fi-rr-calendar-day')"></vs-icon>
                        <span v-if="created_at.created_at">{{ created_at.created_at|date }}</span>
                    </div>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-clock', 'fi-rr-clock-three')"></vs-icon>
                        <span v-if="created_at.created_at">{{ created_at.created_at|time }}</span>
                    </div>
                </div>
            </template>

            <template v-slot:send_date="{send_date}">
                <div v-if="!send_date.send_date">-</div>
                <div v-else>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-calendar', 'fi-rr-calendar-day')"></vs-icon>
                        <span v-if="send_date.send_date">{{ send_date.send_date|date }}</span>
                    </div>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-clock', 'fi-rr-clock-three')"></vs-icon>
                        <span v-if="send_date.send_date">{{ send_date.send_date|time }}</span>
                    </div>
                </div>
            </template>

            <template v-slot:first_action_date="{first_action_date}">
                <div v-if="!first_action_date.first_action_date">-</div>
                <div v-else>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-calendar', 'fi-rr-calendar-day')"></vs-icon>
                        <span v-if="first_action_date.first_action_date">{{first_action_date.first_action_date|date}}</span>
                    </div>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-clock', 'fi-rr-clock-three')"></vs-icon>
                        <span v-if="first_action_date.first_action_date">{{first_action_date.first_action_date|time}}</span>
                    </div>
                </div>
            </template>

            <template v-slot:tmp_first_action_date="{tmp_first_action_date}">
                <div v-if="!tmp_first_action_date.tmp_first_action_date">-</div>
                <div v-else>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-calendar', 'fi-rr-calendar-day')"></vs-icon>
                        <span v-if="tmp_first_action_date.tmp_first_action_date">{{tmp_first_action_date.tmp_first_action_date|date}}</span>
                    </div>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-clock', 'fi-rr-clock-three')"></vs-icon>
                        <span v-if="tmp_first_action_date.tmp_first_action_date">{{tmp_first_action_date.tmp_first_action_date|time}}</span>
                    </div>
                </div>
            </template>

            <template v-slot:action="{action}">
                <div class="flex items-center">
                    <vs-checkbox v-model="action.current" class="moderation__checkbox">Текущая дата</vs-checkbox>

                    <vs-button radius
                               color="success"
                               type="flat"
                               v-bind="$iconData('icon-check', 'fi-rr-check')"
                               @click="leadApprove(action)"
                               v-tooltip="$t('buttons.Approve')"
                    ></vs-button>

                    <vs-button radius
                               color="danger"
                               type="flat"
                               v-bind="$iconData('icon-x', 'fi-rr-cross-small')"
                               @click="leadDecline(action.id)"
                               v-tooltip="$t('buttons.Decline')"
                    ></vs-button>
                </div>
            </template>
        </ds-table>
    </div>
</template>


<script>
import ErrorHandler from "@/utils/errorHandler"
import send from "@/utils/fetch"
import {dateParse} from '@/utils/mixins'
import qs from "qs"

export default {
    mixins: [dateParse],

    data() {
        return {
            isMounted: false,
            load: true,
            leads: [],
            heads: [
                {name: 'global.id', key: 'id', sortKey: 'id', value: 'id', display: true},
                {name: 'global.Email', key: 'email', sortKey: 'email', value: 'email', display: true},
                {name: 'global.Country', key: 'country', sortKey: 'country', value: 'country', display: true},
                {name: 'global.Geo', key: 'geo', sortKey: 'geo', value: 'geo', display: true},
                {name: 'global.Team', key: 'team_name', sortKey: 'team_name', value: 'team_name', display: true},
                {name: 'global.Affiliate', key: 'affiliate_name', sortKey: 'affiliate_name', value: 'affiliate_name', display: true},
                {name: 'global.Advertiser', key: 'advertiser', sortKey: 'advertiser', value: 'advertiser', display: true},
                {name: 'global.Integration', key: 'integration_name', sortKey: 'integration_name', value: 'integration_name', display: true},
                {name: 'global.Status', key: 'group_status', sortKey: 'group_status', value: 'group_status', display: true},
                {name: 'global.Manager', key: 'manager_name', value: 'manager_name', display: true},
                {name: 'statistic.Reg_date', key: 'created_at', sortKey: 'created_at', value: 'created_at', display: true},
                {name: 'global.Send_date', key: 'send_date', sortKey: 'send_date', value: 'send_date', display: true},
                {name: 'global.Action_date', key: 'first_action_date', sortKey: 'first_action_date', value: 'first_action_date', display: true},
                {name: 'global.TMP_Action_date', key: 'tmp_first_action_date', sortKey: 'ftd_status', value: 'tmp_first_action_date', display: true},
                {name: 'global.Actions', key: 'action', value: 'action', display: true}
            ],
            filters: {
                fields: [
                    {name: 'table_filters.manager', type: 'select', label: 'managers', field: 'managers', reKey: 'manager_ids', multiple: true},
                    {name: 'table_filters.affiliate_id', type: 'select', label: 'affiliates', field: 'affiliates', reKey: 'affiliate_ids', multiple: true},
                    {name: 'table_filters.team_id', type: 'select', label: 'teams', field: 'teams', reKey: 'team_ids', multiple: true},
                ],
                options: [],
                selected: []
            },
            table: {
                total: 0,
                page: 1,
                limit: 50
            },
            orderBy: {name: "id", direction: "desc"},
            date: {
                direction: '',
                startDate: new Date(),
                endDate: new Date()
            }
        }
    },

    methods: {
        selectedDate(date) {
            this.date.startDate = date.startDate
            this.date.endDate = date.endDate
        },

        async sort(sort) {
            this.orderBy =  {
                name: sort.name,
                direction: sort.type
            }

            await this.get()
        },

        async page(page) {
            if (this.table.page !== page) {
                this.table.page = page
                await this.get()
            }
        },

        async limit(limit) {
            if (limit !== this.table.limit) {
                this.table.limit = limit

                if (this.table.page !== 1) {
                    await this.page(1)
                } else {
                    await this.get()
                }
            }
        },

        async submitFilter(data) {
            this.filters.selected = data

            if (this.table.page !== 1) {
                await this.page(1)
            } else {
                await this.get()
            }
        },

        async refreshFilter() {
            this.filters.selected = {}

            this.date = {
                direction: '',
                startDate: new Date(),
                endDate: new Date()
            }

            await this.get()
        },

        async leadApprove(data) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: this.$t('confirm.Confirm_action'),
                text: `${this.$t('confirm.Confirm_action')}?`,
                accept: async () => {
                    await send(`${this.$url.moderation.approve}/${data.id}/approve`, 'POST', {
                        data: {
                            deposit_date_type: data.current ? 'current' : 'advertiser_deposit_date'
                        }
                    })

                    await this.get()
                },
                acceptText: this.$t('buttons.Approve'),
                cancelText: this.$t('global.Cancel')
            })
        },

        async leadDecline(id) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: this.$t('confirm.Confirm_action'),
                text: `${this.$t('confirm.Confirm_action')}?`,
                accept: async () => {
                    await send(`${this.$url.moderation.approve}/${id}/decline`, 'POST')

                    await this.get()
                },
                acceptText: this.$t('buttons.Decline'),
                cancelText: this.$t('global.Cancel')
            })
        },

        async get() {
            try {
                this.load = true

                const params = {
                    ...this.table,
                    ...this.filters.selected,
                    order: {...this.orderBy},
                    range_by: this.date.direction,
                    range_from: this.dateParse(this.date.startDate),
                    range_to: this.dateParse(this.date.endDate)
                }

                if (!params.order.direction) {
                    params.order = {name: 'id', direction: 'desc'}
                }

                const response = await send(this.$url.moderation.get, 'GET', {
                    params,
                    paramsSerializer: params => qs.stringify(params, {
                        encode: false,
                        indices: false,
                        arrayFormat: 'brackets',
                    })
                })
                    .then(response => response.data.result)

                this.filters.options = response.filters

                this.table.total = response.total
                this.leads = response.leads

                if (!Array.isArray(this.leads)) {
                    this.leads = [...Object.values(this.leads)]
                }
            } catch (e) {
                new ErrorHandler(e).send
            } finally {
                this.load = false
            }
        }
    },

    async mounted() {
        await this.get()

        this.isMounted = true
    }
}
</script>

<style lang="scss">
.moderation__checkbox {
    .con-slot-label {
        white-space: nowrap;
    }
}
</style>
